import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdFlight, MdTrain, MdHome, MdPerson } from "react-icons/md";
import { FaBus } from "react-icons/fa6";
import { useModal } from "../Sliders/Modal/ModalContext";

const ORANGE = "#FF6A1A";

const TABS = [
  { label: "Home", path: "/", icon: MdHome },
  { label: "Flights", path: "/flights", icon: MdFlight },
  { label: "Bus", path: "/interstate", icon: FaBus },
  { label: "Train", path: "/train", icon: MdTrain },
  { label: "Account", path: "/profile", icon: MdPerson },
] as const;

const Downtab = ({ children }: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { showModal } = useModal();
  const isAuth = useSelector((state: any) => state.client.isAuth);

  return (
    <div className="fixed md:hidden inset-x-0 bottom-0 z-40">
      {children}
      <nav
        className="grid grid-cols-5"
        style={{
          background: "rgba(11,16,48,.94)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          borderTop: "1px solid rgba(255,255,255,.08)",
          paddingBottom: "env(safe-area-inset-bottom)",
        }}
      >
        {TABS.map((tab) => {
          const active =
            tab.path === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(tab.path);
          return (
            <button
              key={tab.label}
              type="button"
              onClick={() => {
                if (tab.path === "/profile" && !isAuth) showModal("authModal");
                else navigate(tab.path);
              }}
              className="flex flex-col items-center justify-center"
              style={{
                height: 62,
                gap: 4,
                background: "transparent",
                border: "none",
                color: active ? ORANGE : "rgba(255,255,255,.55)",
                fontSize: 11,
                fontWeight: active ? 700 : 500,
                fontFamily: "inherit",
                cursor: "pointer",
              }}
            >
              <span
                className="flex items-center justify-center"
                style={{
                  width: 40,
                  height: 26,
                  borderRadius: 13,
                  fontSize: 19,
                  background: active ? "rgba(255,106,26,.16)" : "transparent",
                  transition: "background .2s",
                }}
              >
                <tab.icon />
              </span>
              {tab.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
};
export default Downtab;
